import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $deleteUserAccountsStore } from '@lib/store';
import { PaletteUtils } from '@shared/utils';
import type { GetAccountUsersResponse } from '@shared/api/rest/users';
import { Button, ColorsEnum, Icon, Modal, Text } from '@shared/widgets';
import CloseIcon from '@assets/icons/close.svg';

interface IModalRemoveManager {
  title: string;
  onClose: (confirm?: boolean) => void;
  accountId: number;
  data: GetAccountUsersResponse[];
  isOpen: boolean;
}

export const ModalRemoveManager = (props: IModalRemoveManager) => {
  const deleteUserAccounts = useUnit($deleteUserAccountsStore.store);

  const [managersData, setManagersData] = useState<GetAccountUsersResponse[]>(props.data);
  const [selectedManagers, setSelectedManagers] = useState<string[]>([]);

  useEffect(() => {
    setManagersData(props.data);
  }, [props.data]);

  const closeHandler = () => {
    setSelectedManagers([]);
    props.onClose();
  };
  const confirmRemoveHandler = async () => {
    if (!selectedManagers.length) {
      closeHandler();
      return;
    }
    await Promise.allSettled(
      selectedManagers.map((account) => $deleteUserAccountsStore.events.delete({ userIds: account, accountIds: [props.accountId] })),
    );
    setSelectedManagers([]);
    props.onClose(true);
  };

  return (
    <Modal isOpen={props.isOpen} onClose={closeHandler} title={props.title}>
      {managersData.map((manager) => (
        <div
          key={manager.id}
          className={clsx(
            'flex items-center font-semibold justify-between px-4 bg-ice dark:bg-soft-black py-2 my-3',
            selectedManagers.includes(manager.id) && 'opacity-50',
          )}
        >
          <div className='flex justify-center items-center w-11 h-11 rounded-full bg-primary'>
            <Text color={PaletteUtils.getColor(ColorsEnum.Black, ColorsEnum.White)}>{manager.firstName[0]}</Text>
          </div>
          <Text>
            {manager.firstName} {manager.lastName}
          </Text>
          <Icon
            icon={<CloseIcon />}
            className={clsx('cursor-pointer', selectedManagers.includes(manager.id) && '!cursor-default pointer-events-none')}
            onClick={() => setSelectedManagers((prev) => [...prev, manager.id])}
          />
        </div>
      ))}
      <Button className='mt-8' color='primary' fullWidth disabled={deleteUserAccounts.loading} onClick={confirmRemoveHandler}>
        Confirm
      </Button>
    </Modal>
  );
};
